import type { ComponentProps, CSSProperties, JSX } from 'react';

import { cn } from '~/utils';

export interface IStackProps extends ComponentProps<'div'> {
  gap?: number | `${number}px`;
}

export function Stack({
  style,
  gap = 4,
  className,
  ...rest
}: IStackProps): JSX.Element {
  return (
    <div
      className={cn('flex flex-col', 'gap-[var(--stack-gap)]', className)}
      style={
        {
          ...style,
          '--stack-gap': typeof gap === 'number' ? `${gap * 4}px` : gap,
        } as CSSProperties
      }
      {...rest}
    />
  );
}

export function HStack({ className, ...rest }: IStackProps): JSX.Element {
  return <Stack className={cn('flex-row', className)} {...rest} />;
}
